import { useState } from "react";

import { accordionData } from "./accordion-data";
import { Accordion } from "./components/Accordion";
import { ActivityFilterDiv, AllActivitiesDiv } from "./styles";
import { SidebarProps } from "./types";

export const ActivitySidebar = (props: SidebarProps) => {
  const [isSelected, setIsSelected] = useState<string | undefined>(undefined);

  return (
    <ActivityFilterDiv>
      <AllActivitiesDiv
        selected={isSelected}
        onClick={() => {
          props.setCogDomainFilter(undefined);
          props.setCategoryFilter("");
          setIsSelected(undefined);
        }}
      >
        ALL ACTIVITIES
      </AllActivitiesDiv>
      {accordionData.map(({ title, content }, index) => (
        <Accordion
          title={title}
          content={content}
          key={index}
          setCogDomainFilter={props.setCogDomainFilter}
          setCategoryFilter={props.setCategoryFilter}
          isSelected={isSelected}
          setIsSelected={setIsSelected}
        />
      ))}
    </ActivityFilterDiv>
  );
};
